var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lang.toUpperCase() === 'FR')?_c('button',{staticClass:"langButton textBtn",on:{"click":_vm.changeLang}},[_vm._v("EN")]):_c('button',{staticClass:"langButton textBtn",on:{"click":_vm.changeLang}},[_vm._v("FR")])
}
var staticRenderFns = []

export { render, staticRenderFns }